import React from 'react';
import HttpError from 'styleguide/core/HttpError';

const Error: React.FC = () => {
  return <HttpError code="403" message="Forbidden" inline />;
};

export default React.memo(Error);
